
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import Tooltip from "@/components/common/Tooltip.vue";
  import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
  import ProjectViewManager from "@/entities/scheduler/ProjectViewManager";
  import ProjectViewManagerEntity from "@/entities/scheduler/ProjectViewManagerEntity";
  import ColorCodeTriangle from "@/components/scheduler/ColorCodeTriangle.vue";
  import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";
  import { NOT_ASSIGNED } from "@/data/placeholders";
  import getAvatarPadding from "@/helpers/scheduler/getAvatarPadding";
  import TooltipVariants from "@/entities/TooltipVariants";
  import Checkbox from "@/components/form/Checkbox.vue";

  @Component({
    components: {
      CircleWithInitials,
      ColorCodeTriangle,
      SchedulerItemAvatar,
      Tooltip,
      Checkbox,
    }
  })
  export default class ProjectViewProjectItem extends Vue {
    @Prop({ type: Object, default: () => ({}) }) readonly projectItem!: ProjectViewManager;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    TooltipVariants = TooltipVariants;

    get projectHasManager(): boolean {
      return Boolean(this.itemInfo.managerName);
    }

    get itemInfo(): ProjectViewManagerEntity {
      return this.projectItem!.entityInfo!;
    }

    get isCurrentUserManager(): boolean {
      return Boolean(this.itemInfo.id === this.currentUserId);
    }

    get managerName(): string {
      if (!this.projectHasManager) {
        return NOT_ASSIGNED;
      }
      return this.itemInfo.managerName!;
    }

    get managerHasRequests(): boolean {
      return Boolean(this.itemInfo.requests?.length);
    }

    get avatar(): string {
      if (this.isCurrentUserManager) {
        return "";
      }
      return this.itemInfo.avatar || "";
    }

    get initial(): string {
      return this.managerName.trim().toUpperCase()[0];
    }

    get itemName(): string {
      return this.isCurrentUserManager
        ? this.itemInfo.projectName!
        : this.managerName;
    }

    get contractorsMissing(): boolean {
      const activitiesWithContractors = this.projectItem.projectActivities?.filter(activity => {
        return Boolean(activity.contractor)
      })
      return Boolean(this.projectItem?.projectActivities?.length !== activitiesWithContractors?.length);
    }

    get colorCode(): string {
      if (this.contractorsMissing || !this.projectHasManager) {
        return "danger";
      }
      if (this.managerHasRequests && !this.isCurrentUserManager) {
        return "warning";
      }
      return "";
    }

    get tooltipTitle(): string {
      const managerNotAssignedMsg = "Manager is not assigned";
      const managerHasRequestsMsg = "Manager has pending contractor requests";
      const contractorsMissingMsg = "one or more project tasks do not have contractors";

      if (!this.projectHasManager && this.contractorsMissing) {
        return `${managerNotAssignedMsg} and ${contractorsMissingMsg}`;
      }
      if (this.contractorsMissing && this.managerHasRequests && !this.isCurrentUserManager) {
        return `${managerHasRequestsMsg} and ${contractorsMissingMsg}`
      }
      if (!this.projectHasManager) {
        return managerNotAssignedMsg;
      }
      if (this.contractorsMissing) {
        return contractorsMissingMsg.substring(0,1).toUpperCase() + contractorsMissingMsg.substring(1);
      }
      if (this.managerHasRequests && !this.isCurrentUserManager) {
        return managerHasRequestsMsg;
      }
      return "";
    }

    get avatarsPadding(): string {
      return getAvatarPadding(this.colorCode);
    }
  }
